import { Suspense } from 'react';

import { useCurrentUserPlusMembership } from '~/domains/auth/queries';
import { priceToKoreanMoneyToString } from '~/domains/payment/utils';

import { MembershipStandard16x16Icon } from '~/assets/icons';

/**
 * 베이직 연간 -> N원 할인혜택
 * 베이직, 스탠다드 -> 월 N원 할인 혜택
 */

const PlusMembershipTopBadgeContainer = () => {
  const { data } = useCurrentUserPlusMembership();

  if (data && data.unusedCouponDiscountPrice > 0) {
    return (
      <span className="flex items-center gap-4 rounded-12 bg-[#21ab731a] px-8 py-4 text-bonuspackGreen-text typo-footnote300-semibold">
        <MembershipStandard16x16Icon />
        <span>
          {priceToKoreanMoneyToString(data.unusedCouponDiscountPrice)}원 혜택
          받는 중
        </span>
      </span>
    );
  }

  return null;
};

function PlusMembershipTopBadge() {
  return (
    <Suspense fallback={<></>}>
      <PlusMembershipTopBadgeContainer />
    </Suspense>
  );
}

export default PlusMembershipTopBadge;
